import styled from 'styled-components';

export type LabelProps = {
    primary?: boolean;
    grey?: boolean;
    small?: boolean;
};

export const Label = styled.span
    .withConfig({ shouldForwardProp: (prop) => !['primary', 'grey', 'small'].includes(prop) })
    .attrs<LabelProps>((props) => ({
        className: 'app-label',
        small: false,
    }))`
    &.app-label {
        font-style: normal;
        font-weight: ${(props) => (props.primary ? 'bold' : 'normal')};

        font-size: ${(props) => (props.small ? '0.71rem' : '0.85rem')};
        line-height: ${(props) => (props.small ? '1rem' : '1.42rem')};

        padding: 0.14em 0.36em;
        color: ${(props) =>
            props.primary
                ? props.theme.colors.base_grey
                : props.grey
                  ? props.theme.colors.road_grey_700
                  : props.theme.colors.road_grey_900};
    }
`;
